(() => {
  const state = window.LuciaFeaturedSeries || {};
  const rows = () => Array.from(document.querySelectorAll('[data-lucia-series-row]'));
  const intros = () => Array.from(document.querySelectorAll('[data-lucia-series-intro]'));
  const scrollBehavior = () => (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  );

  const updateMotion = () => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const isMobile = window.matchMedia('(max-width: 760px)').matches;

    rows().forEach((row) => {
      if (row.hidden || row.dataset.motionEnabled === 'false') {
        row.classList.remove('is-motion-ready');
        row.classList.add('is-visible');
        return;
      }

      const rect = row.getBoundingClientRect();
      const enter = Number(isMobile ? row.dataset.mobileEnter : row.dataset.enter) || 82;
      const exit = Number(isMobile ? row.dataset.mobileExit : row.dataset.exit) || 8;
      const visible = rect.top <= viewportHeight * (enter / 100) && rect.bottom >= viewportHeight * (exit / 100);

      row.classList.add('is-motion-ready');
      row.classList.toggle('is-visible', visible);
    });
  };

  const scheduleMotion = () => {
    if (state.frame) return;
    state.frame = requestAnimationFrame(() => {
      state.frame = 0;
      updateMotion();
    });
  };

  const applyFilter = (family, source) => {
    rows().forEach((row) => {
      const show = family === 'all' || row.dataset.family === family;
      row.hidden = !show;
    });

    intros().forEach((intro) => {
      intro.querySelectorAll('[data-lucia-family-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.luciaFamilyFilter === family));
      });
    });

    state.activeFamily = family;
    scheduleMotion();

    if (source && window.matchMedia('(max-width: 760px)').matches) {
      source.scrollIntoView({ block: 'nearest', inline: 'center', behavior: scrollBehavior() });
    }
  };

  const bindIntro = (intro) => {
    if (intro.dataset.luciaBound === 'true') return;
    intro.dataset.luciaBound = 'true';
    intro.addEventListener('click', (event) => {
      const button = event.target.closest('[data-lucia-family-filter]');
      if (!button) return;
      applyFilter(button.dataset.luciaFamilyFilter, button);
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll?.('[data-lucia-series-intro]').forEach(bindIntro);
    if (state.activeFamily) applyFilter(state.activeFamily);
    scheduleMotion();
  };

  if (!state.globalBound) {
    state.globalBound = true;
    window.addEventListener('scroll', scheduleMotion, { passive: true });
    window.addEventListener('resize', scheduleMotion, { passive: true });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const row = event.target.querySelector?.('[data-lucia-series-row]');
      if (row) {
        row.hidden = false;
        row.classList.add('is-visible');
        row.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
      }
    });
  }

  state.applyFilter = applyFilter;
  state.initialize = initialize;
  state.updateMotion = updateMotion;
  window.LuciaFeaturedSeries = state;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
})();
